export default "__VITE_ASSET__8cf42e9c__"